<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-simple-table leftWidth="15rem;" :items="dataList" @showCriteriaModal="showCriteriaModal" />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <!-- table -->
              <v-data-table
                class="mb-4 custom-table sticky-header"
                :loading="loading"
                :headers="headers"
                :items="formData.states"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal')
                }"
                :items-per-page="-1"
                hide-default-footer
              >
                <!-- custom templates -->
                <template #[`item.status`]="{ item }">
                  <el-table-enum
                    enumName="searchOrderStatusList"
                    :item="item.status"
                  />
                </template>
                <!-- basic templates -->
                <template slot="loading"> {{ $t('Kraunasi...') }} </template>
                <template slot="no-results">
                  {{ $t('Duomenų nėra') }}
                </template>
                <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
                <template #[`footer.page-text`]="props">
                  {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
                  {{ $t('iš') }}
                  {{ props.itemsLength }}
                </template>
              </v-data-table>
            </v-col>
            <v-col v-if="showPdfFile" cols="12" md="6">
              <el-PDF-viewer download :file="pdfFile" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              title="Atgal"
              @click.native="back()"
              :loading="loading"
            />
            <el-button
              v-if="formData.canSearch"
              class="mr-1"
              color="primary"
              :title="formData.source == 'self-service' && formData.withdrawal_method == '01' ? 'Suteikti išrašą' : 'Atlikti paiešką'"
              @click.native="confirm('dosearch')"
              :loading="loading"
            />
            <el-button
              v-if="formData.canWithdraw"
              class="mr-1"
              color="primary"
              title="Atsiimta"
              @click.native="confirm('withdrawn')"
              :loading="loading"
            />
            <el-button
              v-if="formData.canPressPayed"
              class="mr-1"
              color="primary"
              title="Apmokėta"
              @click.native="confirm('payed')"
              :loading="loading"
            />
            <el-button
              v-if="formData.canApprove"
              class="mr-1"
              color="primary"
              title="Patvirtinti"
              @click.native="confirm('approve')"
              :loading="loading"
            />
            <el-button
              v-if="formData.canReject"
              class="mr-1"
              color="danger"
              title="Atmesti"
              @click.native="confirm('reject')"
              :loading="loading"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- modal -->
    <modal-criteria
      v-model="criteriaModal"
      :loading="loading"
      :item="formData"
    />

     <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      v-model="showConfirmModal"
      :loading="loading"
      :rejectReason="modalinfo"
      :rejectReasonType="'statement'"
      @rejectReasonText="ReasonText"
      @rejectReasonTextEN="ReasonTextEN"
      @confirmData="actionData(confirmType)"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalConfirm from '@/components/modals/ModalConfirm'
import ModalCriteria from '@/components/modals/ModalCriteria'

export default {
  name: 'AdminOrderForm',
  components: {
    ModalConfirm,
    ModalCriteria,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {
        criteria_array: {},
      },
      pdfFile:  {},
      showConfirmModal: false,
      confirmTitle: '',
      confirmText: '',
      confirmType: '',
      rejectReason: null,
      rejectReasonEN: null,
      rejectReasonType: null,
      modalinfo: false,
      criteriaModal: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Būsenos data'),
          align: 'center',
          sortable: false,
          value: 'date',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Darbuotojas / Sistema'),
          align: 'start',
          value: 'user',
        },
      ]
    },
    showPdfFile(){
      return this.pdfFile && Object.keys(this.pdfFile).length != 0
    },
    showFiz() {
      return this.formData.person_type === 'FIZ'
    },
    showJur() {
      return this.formData.person_type === 'JUR'
    },
    dataList() {
      let list = []
      list = [
        {
          title: 'Užklausos gavimo data',
          value: this.formData.receive_date || '',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Užklausos gavimo data",
        },
        {
          title: 'Duomenų apimtis',
          value: this.formData.type || '',
          enumName: 'dataVolumeOrderIreg',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Duomenų apimtis",
        },
        {
          title: 'Paieškos kriterijai',
          criteriaModal: true,
        },
        {
          title: 'JA kodas',
          value: this.formData.code || '',
          hide: !this.showJur,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Juridinio asmens kodas",
        },
        {
          title: 'Valstybė',
          value: this.formData.country || '',
          hide: !this.showJur,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Valstybė",
        },
        {
          title: 'Vardas',
          value: this.formData.name || '',
          hide: !this.showFiz,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Vardas",
        },
        {
          title: 'Pavardė',
          value: this.formData.lastname || '',
          hide: !this.showFiz,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Pavardė",
        },
        {
          title: 'Asmens kodas',
          value: this.formData.code || '',
          hide: !this.showFiz,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Asmens kodas",
        },
        {
          title: 'ILTU kodas',
          value: this.formData.code || this.formData.criteria_array.iltu_code || '',
          hide: this.formData.person_search_type != 'iltu',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. ILTU kodas",
        },

        {
          title: 'Gimimo data',
          value: this.formData.birth_date || '',
          hide: !this.formData.birth_date,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Gimimo data",
        },
        {
          title: 'Identifikavimo kodas',
          value: this.formData.mandate_code || '',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Identifikavimo kodas",
        },
        {
          title: 'Įgaliojimo notarinio registro Nr.',
          value: this.formData.notarial_code || '',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Įgaliojimo notarinio registro nr",
        },
        {
          title: 'Išrašo dokumento kalba',
          value: this.formData.language || '',
          enumName: 'docLanguage',
        },
        {
          title: 'Duomenų naudojimo tikslas',
          value: this.formData.purpose || '',
          file: this.formData.purpose_file,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Duomenų naudojimo tikslas",
        },
        {
          title: 'Teisinis pagrindas',
          value: this.formData.legal_basis || '',
          file: this.formData.legal_basis_file,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Teisinis pagrindas",
          hide: !this.formData.legal_basis && !this.formData.legal_basis_file?.length
        },
        {
          title: 'Atsiėmimo būdas',
          value: this.formData.withdrawal_method || '',
          enumName: 'withdrawalOrder',
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Atsiėmimo būdas",
        },
      ]
      // recipient
      if(this.formData.recipient && Object.keys(this.formData.recipient).length > 0){
        let fields = {}
        if(this.formData.recipient['person_type'] === 'FIZ') {
          fields = {
            fullname: 'Pareigos, vardas ir pavardė',
            code: 'Asmens kodas',
            address: 'Adresas',
            city: 'Pašto kodas, miestas',
            email_address: 'El. paštas',
            invoice_required: 'Reikia sąskaitos faktūros',

          }
        } else {
          fields = {
            fullname: 'Pavadinimas',
            code: 'Juridinio asmens kodas',
            address: 'Buveinės adresas',
            city: 'Pašto kodas, miestas',
            email_address: 'El. paštas',
            invoice_required: 'Reikia sąskaitos faktūros',
          }
        }
        Object.keys(fields).map(key => {
          if(this.formData.recipient[key] && key != 'invoice_required'){
            let obj = {}
            obj.title = fields[key]
            obj.value = this.formData.recipient[key] 
            list.push(obj)
          } else if(key === 'invoice_required'){
              let obj = {}
              obj.title = fields['invoice_required']
              obj.value = this.formData.recipient[key] ? 'Taip' : 'Ne'
              list.push(obj)
          }
        })
        fields = {
          invoice_fullname: 'Pareigos, vardas ir pavardė / Pavadinimas',
          invoice_address: 'Adresas / Buveinės adresas',
          invoice_city: 'Pašto kodas, miestas',
          invoice_code: 'Asmens / Juridinio asmens kodas',
        }
        if(this.formData.recipient['invoice_required']){
          Object.keys(fields).map(key => {
            if(this.formData.recipient[key]){
              let obj = {}
              obj.title = fields[key]
              obj.addBullet = true
              obj.value = this.formData.recipient[key] 
              list.push(obj)
            } 
          })
        } 
      }
      list.push(
        {
          title: 'Atmetimo aprašymas (LT)',
          value: this.formData.reject_reason || '',
          hide: !this.formData.reject_reason,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Atmetimo priežastis",
        },
        {
          title: 'Atmetimo aprašymas (EN)',
          value: this.formData.reject_reason_en || '',
          hide: !this.formData.reject_reason_en,
          tooltip: "Ireg. Pagrindinis. Paieška. Išrašas. Atmetimo priežastis",
        }
      )
      return list
    },
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getList() {
      return this.$route.params.list || null
    },
    getTitle() {
      return `${this.$t(`Išrašas`)}: ${this.formData.number || '-'}`
    },
      getPDFData() {
      return this.formData?.statement
        ? Object.keys(this.formData?.statement).length != 0
        : false
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    showCriteriaModal() {
      this.criteriaModal = true
    },
    getPdfFile(statement) {
      this.pageloading = true
      this.$axios
        .get(`uploads/${statement.id}/download`)
        .then((res) => {
          this.pdfFile = res.data
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    back() {
      if(this.getList){
        this.$router.push({ name: 'searchList' })
      } else {
        this.$router.push({ name: 'searchOrders' })
      }
    },
    getResponceTextByType(type) {
      switch (type) {
        case 'reject':
          return 'Sėkmingai atmesta'
        case 'approve':
          return 'Sėkmingai patvirtinta'
        case 'payed':
          return 'Išrašo būsena sėkmingai pakeista į "Apmokėta ir vykdoma"'
        case 'withdrawn':
          return 'Išrašas sėkmingai išduotas'
        case 'dosearch':
          return 'Sėkmingai sugeneruota'
        default:
          return ''
      }
    },
    confirm(type) {
       switch (type) {
        case 'reject':
          this.confirmTitle = 'Atmesti'
          this.confirmText = 'Ar tikrai norite atmesti?'
          this.confirmType = 'reject'
          this.modalinfo = true
          this.showConfirmModal = true
          this.rejectReasonType = 'statement'
          break 
        case 'approve':
          this.confirmTitle = 'Patvirtinti'
          this.confirmText = 'Ar tikrai norite patvirtinti išrašo išdavimą?'
          this.confirmType = 'approve'
          this.modalinfo = false
          this.showConfirmModal = true
          break 
        case 'payed':
          this.confirmTitle = 'Gautas apmokėjimas'
          this.confirmText = 'Ar tikrai norite žymėti kaip apmokėtą?'
          this.confirmType = 'payed'
          this.modalinfo = false
          this.showConfirmModal = true
          break 
        case 'withdrawn':
          this.confirmTitle = 'Atsiimta'
          this.confirmText = 'Ar tikrai norite žymėti kaip atsiimtą?'
          this.confirmType = 'withdrawn'
          this.modalinfo = false
          this.showConfirmModal = true
          break 
        case 'dosearch':
          this.actionData('dosearch')
          break
        default:
          break
      }
    },
    ReasonText(text){
      this.rejectReason = text
    },
    ReasonTextEN(text){
      this.rejectReasonEN = text
    },
    actionData(type) {
      this.loading = true
      let formData = {}
      if(type === 'reject'){
        formData.reject_reason = this.rejectReason
        formData.reject_reason_en = this.rejectReasonEN

      }
      this.$axios
        .post(`statement-orders/${this.getId}/${type}`, formData)
        .then((res) => {
          this.$root.$emit('DATA_OK', this.getResponceTextByType(type))
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showConfirmModal = false
        })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`statement-orders/${this.getId}`)
        .then((res) => {
          this.formData = res.data.statementOrder
          this.getPDFData && this.getPdfFile(this.formData.statement)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
